import { defaultTo } from 'lodash';
import { IModel, ModelRecord } from '.';

export interface IRegionModel extends IModel {
  regionId: number;
  name: string;
}
export class RegionModel implements ModelRecord<IRegionModel> {
  rowVersion: string;
  regionId: number;
  name: string;

  constructor(params?: Partial<IRegionModel>) {
    this.rowVersion = defaultTo(params?.rowVersion, '');
    this.regionId = defaultTo(params?.regionId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
